import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NovaMarkdownPipe } from '../../nova-markdown.pipe';

/**
 * Bulleted list of strings, optional title. Each item renders inline markdown
 * (bold, italic, code, links) via {@link NovaMarkdownPipe} into a sanitized `[innerHTML]`.
 */
@Component({
  selector: 'card-list',
  standalone: true,
  imports: [CommonModule, NovaMarkdownPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss'],
})
export class CardListComponent {
  @Input() title: string | null = null;
  @Input() items: string[] = [];

  trackItem(i: number, item: string): string {
    return i + ':' + item;
  }
}
